export default "__VITE_ASSET__DFWZhMI7__"